import React, { useEffect, useRef } from 'react';
import { useSelector } from 'react-redux';
import { store } from 'redux/store';
import {
  setCurrentTab,
} from 'redux/reducers/meteorologyFieldsLayoutReducer';
import { selectCPMFTrackingForecastSubpage } from 'redux/reducers/meteorologyFieldsTrackingForecastControlPanelReducer';
import { SUBPAGE_NAMES } from 'types/Meteorology/Fields/TrackingForecast/DetailedView';
import { CHART_TYPE_LINE, CHART_TYPE_HEATMAP } from 'types/Meteorology/TrackingForecast';
import RoundTabButton from 'components/DesignSystem/Tabs/DiscreteTabs/RoundTabButton';
import { Card } from 'react-bootstrap';
import useControls from 'hooks/Meteorology/Fields/TrackingForecast/DetailedView/useControls';
import Button from 'components/DesignSystem/Button';
import TFDVChart from 'components/Meteorology/Fields/TrackingForecast/DetailedView/Chart';
import useChartData from 'hooks/Meteorology/Fields/TrackingForecast/DetailedView/useChartData';
import useHeatmapAwareDownload from 'hooks/Meteorology/TrackingForecast/useHeatmapAwareDownload';
import DetailedViewMobile from 'components/Meteorology/Fields/TrackingForecast/DetailedView/Mobile';
import useIsMobile from 'utils/hooks/useIsMobile';

import './index.scss';

export default function DetailedView() {
  const isMobile = useIsMobile();
  useEffect(() => {
    store.dispatch(setCurrentTab('trackingforecast/detailedview'));
  }, []);
  const subpage = useSelector(selectCPMFTrackingForecastSubpage);
  const { subpageButtonProps, chartMode, setChartMode } = useControls();
  const dvImages = useRef<HTMLDivElement>(null);
  // #2009 item 8: heatmap na tela → PDF com a tabela inteira; gráfico de linhas → imagem.
  const { data: chartOption } = useChartData();
  const { download, label: downloadLabel } = useHeatmapAwareDownload(dvImages, chartOption);
  const filename = `mapas_e_meteogramas_acompanhamento_previsao_${SUBPAGE_NAMES[subpage].split(' ').join('_').toLowerCase()}`;

  if (isMobile) {
    return <DetailedViewMobile />;
  }

  return (
    <>
      <div className="d-flex justify-content-center round-discrete-tabs">
        {subpageButtonProps.map((buttonProps) => (
          <RoundTabButton
            key={buttonProps.text}
            onClick={buttonProps.onClick}
            text={buttonProps.text}
            active={buttonProps.active}
          />
        ))}
      </div>
      <Card className="content-card p-3 mx-5 mt-4 mb-5 h-100">
        <div className="d-flex justify-content-end">
          <Button
            className={`chart-mode-button${chartMode === CHART_TYPE_LINE ? ' active' : ''}`}
            type="tertiary"
            icon="line_axis"
            onClick={() => setChartMode(CHART_TYPE_LINE)}
          />
          <Button
            className={`ms-1 chart-mode-button${chartMode === CHART_TYPE_HEATMAP ? ' active' : ''}`}
            type="tertiary"
            icon="table_rows"
            onClick={() => setChartMode(CHART_TYPE_HEATMAP)}
          />
          <Button
            className="ms-3"
            type="tertiary"
            icon="download"
            onClick={download(filename)}
            aria-label={downloadLabel}
            title={downloadLabel}
          />
        </div>
        <div ref={dvImages}>
          <TFDVChart />
        </div>
      </Card>
    </>
  );
}
